export const sliderItems = [
    {
        id: 1,
        img: "https://firebasestorage.googleapis.com/v0/b/shop-cf072.appspot.com/o/yellow.png?alt=media&token=485800be-e52b-4ed6-bc5f-eba2cd0d2401",
        title: "SUMMER SALE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "f5fafd",
        link: "summer"
    },
    {
        id: 2,
        img: "https://firebasestorage.googleapis.com/v0/b/shop-cf072.appspot.com/o/pink.png?alt=media&token=603f4029-e277-4bce-a8ee-c1f7a9a94f0f",
        title: "VIVID COLLECTION",
        desc: "FIND NEW VIVID COLLECTION ITEMS AT UP TO 20% OFF.",
        bg: "fcf1ed",
        link: "vivid"
    },
    {
        id: 3,
        img: "https://firebasestorage.googleapis.com/v0/b/shop-cf072.appspot.com/o/jeans.png?alt=media&token=1d9b6f60-6877-40b8-a249-bf682a6a6974",
        title: "JEANS LOVER",
        desc: "CHECK OUT OUR JEANS LOVER SELECTION FOR THE VERY BEST IN UNIQUE PIECES.",
        bg: "fbf0f4",
        link: "jeans"
    },
];


export const categories = [
    {
        id: 1,
        img: "https://firebasestorage.googleapis.com/v0/b/shop-cf072.appspot.com/o/women.jpg?alt=media&token=3e6dd221-36c0-4075-b52f-56f7cdc16372",
        title: "WHAT WOMEN WANT",
        category: "women",
    },
    {
        id: 2,
        img: "https://firebasestorage.googleapis.com/v0/b/shop-cf072.appspot.com/o/sport.jpeg?alt=media&token=bb2273b4-50a8-4ec6-a96d-4d48b75f2172",
        title: "SPORTS MANIA",
        category: "sports",
    },
    {
        id: 3,
        img: "https://firebasestorage.googleapis.com/v0/b/shop-cf072.appspot.com/o/jacket.jpg?alt=media&token=8328efb8-32cd-49c1-90cc-33c068926576",
        title: "JACKET STYLE !!",
        category: "jackets",
    },
    {
        id: 4,
        img: "https://firebasestorage.googleapis.com/v0/b/shop-cf072.appspot.com/o/street.jpg?alt=media&token=b96fc476-3053-41b5-a785-f6e1f98ff093",
        title: "STREET FASHION",
        category: "street",
    }, 
    {
        id: 5,
        img: "https://firebasestorage.googleapis.com/v0/b/shop-cf072.appspot.com/o/under.jpg?alt=media&token=8be1ad12-c061-4450-8ae9-7414fdde6732",
        title: "EASY UNDERWEAR",
        category: "underwears",
    },
];


export const categoriesOptions = [
    { value: 'men', label: 'Men' },
    { value: 'women', label: 'Women' },
    { value: 'dresses', label: 'Dresses' },
    { value: "coats", label: "Coats" },
    { value: "jackets", label: "Jackets" },
    { value: "shirts", label: "Shirts" },
    { value: "pants", label: "Pants "},
    { value: "jeans", label: "Jeans" },
    { value: "skirts", label: "Skirts" },
    { value: "sports", label: "Sports" },
    { value: "bikinis", label: "Bikinis" },
    { value: "underwears", label: "Underwears" },
    { value: "accessories", label: "Accessories" },
    { value: "shoes", label: "Shoes" },
    { value: "summer", label: "Summer" },
    { value: "vivid", label: "Vivid" },
    { value: "street", label: "Street" }
];    

export const sizeOptions = [
    { value: "free", label: "Free" },
    { value: "XS", label: "XS" },
    { value: "S", label: "S" },
    { value: "M", label: "M" },
    { value: "L", label: "L" },
    { value: "XL", label: "XL" },
    { value: "XXL", label: "XXL" },
];

export const colorOptions = [
    { value: "white", label: "White"},
    { value: "black", label: "Black"},
    { value: "gray", label: "Gray"},
    { value: "red", label: "Red"},
    { value: "pink", label: "Pink"},
    { value: "orange", label: "Orange"},
    { value: "blue", label: "Blue"},
    { value: "green", label: "Green"},
    { value: "navy", label: "Navy"},
    { value: "yellow", label: "Yellow"},
    { value: "beige", label: "Beige"},
];

export const stockOptions = [
    { value: true, label: "Yes"},
    { value: false, label: "No"},
];